module.exports = __webpack_public_path__ + "img/v2.7a67f58.png";